/* Interactive constituency map for /map/ */
(function () {
    var API_BASE = 'https://pollingreport.uk/api/v1';
    var LEAFLET_JS_CDN = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js';
    var LEAFLET_CSS_CDN = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css';

    var partyColors = {
        reform: '#26C6DA',
        lab: '#FF1744',
        con: '#1E88E5',
        lib: '#F6A800',
        snp: '#F2D232',
        green: '#5AD313',
        plaid: '#00C853',
        other: '#BDBDBD'
    };

    var roots = document.querySelectorAll('[data-ukpr-map-widget]');
    if (!roots.length) return;

    roots.forEach(function (root) {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        initWidget(root);
    });

    function initWidget(root) {
        var canvas = root.querySelector('[data-map-canvas]');
        var hoverName = root.querySelector('[data-map-hover]');
        var statusEl = root.querySelector('[data-map-status]');
        var modelSelect = root.querySelector('[data-map-model]');
        var flippedSelect = root.querySelector('[data-map-flipped]');
        var showBtns = root.querySelectorAll('[data-map-show]');

        var state = {
            model: modelSelect ? (modelSelect.value || 'uniform') : 'uniform',
            show: 'winner',
            flipped: '',
            allFeatures: null,
            map: null,
            layer: null
        };

        function setStatus(msg) {
            if (statusEl) statusEl.textContent = msg || '';
        }

        function setHover(msg) {
            if (hoverName) hoverName.textContent = msg || '';
        }

        function ensureLeaflet(done) {
            function ensureCss(cb) {
                var existing = document.querySelector('link[data-ukpr-leaflet-css]');
                if (existing) {
                    cb();
                    return;
                }
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = LEAFLET_CSS_CDN;
                link.setAttribute('data-ukpr-leaflet-css', 'true');
                link.onload = cb;
                link.onerror = cb;
                document.head.appendChild(link);
            }

            function ensureJs(cb) {
                if (window.L && window.L.map) {
                    cb();
                    return;
                }

                var current = document.querySelector('script[data-ukpr-leaflet-js]');
                if (current) {
                    current.addEventListener('load', cb, { once: true });
                    return;
                }

                var script = document.createElement('script');
                script.src = LEAFLET_JS_CDN;
                script.setAttribute('data-ukpr-leaflet-js', 'true');
                script.onload = cb;
                script.onerror = cb;
                document.head.appendChild(script);
            }

            ensureCss(function () {
                ensureJs(done);
            });
        }

        function isFlipped(feature) {
            var p = feature && feature.properties ? feature.properties : {};
            if (!p.WINNER || !p.INCUMBENT) return false;
            return String(p.WINNER).toLowerCase() !== String(p.INCUMBENT).toLowerCase();
        }

        function shouldInclude(feature) {
            if (state.flipped === 'true') return isFlipped(feature);
            if (state.flipped === 'false') return !isFlipped(feature);
            return true;
        }

        function getSeatColor(feature) {
            var p = feature && feature.properties ? feature.properties : {};
            var key = state.show === 'incumbent' ? p.INCUMBENT : p.WINNER;
            key = key ? String(key).toLowerCase() : '';
            return partyColors[key] || '#BDBDBD';
        }

        function styleFeature(feature) {
            return {
                color: getSeatColor(feature),
                fillColor: getSeatColor(feature),
                weight: 0.8,
                opacity: 0.9,
                fillOpacity: 0.7
            };
        }

        function onEachFeature(feature, layer) {
            layer.on({
                click: function () {
                    var code = feature && feature.properties ? feature.properties.CODE : null;
                    if (!code) return;
                    window.location.href = '/seats/' + encodeURIComponent(code) + '/';
                },
                mouseover: function () {
                    var name = feature && feature.properties ? feature.properties.NAME : '';
                    setHover(name || '');
                },
                mouseout: function () {
                    setHover('');
                }
            });
        }

        function redrawLayer() {
            if (!state.map || !state.allFeatures) return;

            if (state.layer) {
                state.map.removeLayer(state.layer);
            }

            var filtered = {
                type: 'FeatureCollection',
                features: (state.allFeatures.features || []).filter(shouldInclude)
            };

            state.layer = window.L.geoJSON(filtered, {
                style: styleFeature,
                onEachFeature: onEachFeature
            }).addTo(state.map);

            var count = filtered.features.length;
            setStatus(count ? ('Showing ' + count + ' seats') : 'No seats match this filter');
        }

        function initMap() {
            if (!canvas || state.map) return;

            state.map = window.L.map(canvas, {
                attributionControl: false,
                zoomControl: true,
                boxZoom: false,
                doubleClickZoom: false,
                dragging: true,
                scrollWheelZoom: false,
                minZoom: 6,
                maxZoom: 14
            }).setView([54.00366, -2.547855], 6);

            window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; OpenStreetMap'
            }).addTo(state.map);
        }

        function fetchMapData() {
            setStatus('Loading map...');

            var params = [
                'boundaries=2024',
                'model=' + encodeURIComponent(state.model)
            ];

            var url = API_BASE + '/map?' + params.join('&');
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onload = function () {
                if (xhr.status !== 200) {
                    setStatus('Map failed to load');
                    return;
                }

                try {
                    var data = JSON.parse(xhr.responseText);
                    state.allFeatures = data;
                    redrawLayer();
                } catch (err) {
                    setStatus('Map data error');
                }
            };
            xhr.onerror = function () {
                setStatus('Map failed to load');
            };
            xhr.send();
        }

        showBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var value = btn.getAttribute('data-map-show') || 'winner';
                if (value === state.show) return;
                state.show = value;
                showBtns.forEach(function (b) {
                    b.classList.toggle('is-active', b === btn);
                });
                redrawLayer();
            });
        });

        if (modelSelect) {
            modelSelect.addEventListener('change', function () {
                state.model = modelSelect.value || 'uniform';
                fetchMapData();
            });
        }

        if (flippedSelect) {
            flippedSelect.addEventListener('change', function () {
                state.flipped = flippedSelect.value;
                redrawLayer();
            });
        }

        ensureLeaflet(function () {
            if (!window.L || !window.L.map) {
                setStatus('Map library failed to load');
                return;
            }
            initMap();
            fetchMapData();
        });
    }
})();
